import { CommonDtoKeysEnum } from '@zaoblako/shared/common/enums/common-dto-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';

import * as yup from 'yup';

/** {@link PaginationQueryInterface.limit} default vaue */
export const DEFAULT_LIMIT = 100;

/** {@link PaginationQueryInterface.offset} default value */
export const DEFAULT_OFFSET = 0;

/** Pagination query parameters (required) */
export interface PaginationRequiredQueryInterface {
  /** How many items need to take ({@link DEFAULT_LIMIT} by default) */
  limit: number;
  /** How many items need to skip ({@link DEFAULT_OFFSET} by default) */
  offset: number;
}

/** Pagination query parameters (required) - DTO schema */
export const PaginationRequiredQueryDto = SerdeDtoClass.create<PaginationRequiredQueryInterface>(CommonDtoKeysEnum.PAGINATION_REQUIRED_FIND_DTO, {
  limit: {
    label: 'Элементов на странице',
    default: DEFAULT_LIMIT,
    serializer: yup
      .number()
      .integer(DtoMessageEnum.NOT_INTEGER)
      .min(1, 'Список не может содержать меньше 1 элемента')
      .max(500, 'Список может быть не более 500 элементов'),
  },
  offset: {
    label: 'Элементов пропущено',
    default: DEFAULT_OFFSET,
    serializer: yup
      .number()
      .integer(DtoMessageEnum.NOT_INTEGER)
      .min(0, 'Нельзя пропустить отрицательное число элементов'),
  },
});

